var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstudiante8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 94,
    viewBox: "0 0 57 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60001 73.57L19.72 62.94V32.56L1.60001 43.19V73.57Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.390015 44.29L1.60001 44.98V73.57L0.390015 72.98V44.29Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.58 71.04L39.54 61.18V41.91L22.58 51.77V71.04Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 54.5V51.7H22.58V53.62L39.65 63.48L56.61 53.62",
    fill: "#EAEAEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 54.5V51.7H22.58V53.62L39.65 63.48L56.61 53.62",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.65 82.75L56.61 72.89V53.62L39.65 63.48V82.75Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 51.7L39.54 41.84L22.58 51.7L39.65 61.56L56.61 51.7Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45 21.24C42.592 19.3458 39.5799 18.3868 36.52 18.54H36.47H36.25C31.44 19.09 30.97 21.43 26.76 33.67L19.54 39.44L21.9 41.35C21.9 41.35 31.05 38.79 32.31 36.55C32.7204 35.8291 33.0877 35.0844 33.41 34.32L34.01 42.71C19.71 49.71 18.42 51.85 20.12 70.92L23.93 73.03C24.33 60.4 24.76 55.24 34.46 51.97C29.63 57.23 29.55 63.37 30.78 77.25L34.6 79.4C35.31 66.71 37.07 60.76 42.16 57.08C45.95 54.33 49.78 53.56 49.36 48.9L49.05 42.38C50.1176 41.1214 50.8533 39.6157 51.19 38C52.11 32.43 49.53 24.36 45 21.24Z",
    fill: "#252525",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.13 71C12.69 74.87 16.25 78 23.94 73.11L20.13 71Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.79 77.28C24.7 80.68 26.42 86 34.6 79.4L30.79 77.28Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 53.34V50.78L0.390015 42.53V44.29L33.18 63.16L51.3 52.54",
    fill: "#DEDEDE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 53.34V50.78L0.390015 42.53V44.29L33.18 63.16L51.3 52.54",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 93.54L51.3 82.92V52.54L33.18 63.16V93.54Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 50.78L18.52 31.91L0.390015 42.53L33.18 61.41L51.3 50.78Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 93.54L31.98 92.94V62.56L33.18 63.16V93.54Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.59 47.64C32.99 49.36 37.2 56.64 41.66 48.9L38.59 47.64Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.53 43.67L19.89 51.08L11.28 46.13L23.92 38.72L32.53 43.67Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.14 44.89L25.5 52.3L16.89 47.35L29.53 39.94L38.14 44.89Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.55 39.47C11.96 39.47 13.3 45.67 21.91 41.38L19.55 39.47Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.58 24.47C32.32 30 33.24 31.91 33.42 34.35",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.34 10.27C32 17.55 33.09 19.61 36.27 20.55L36.16 21.35C36.16 21.35 35.79 22.83 38.67 22.83C41.55 22.83 42.67 21.97 42.54 19.33C42.74 18.85 44.09 15.07 43.86 14.26C42.7 10.15 37.93 4.63 35.34 10.27Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.16 13L35.34 9.5L39.7 10.66L40.53 16.79C40.53 16.79 41.21 14.41 42.31 14.79C43.41 15.17 43.39 16.85 41.83 18.52C40.96 19.43 42.54 19.38 42.54 19.38C42.54 19.38 46.04 16.14 45.89 12.6C45.74 9.06 42.89 5.01 35.89 7.69C35.93 7.64 30.82 8.12 34.16 13Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.59 47.64C32.99 49.36 37.2 56.64 41.66 48.9L38.59 47.64Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M51.19 38C50.67 41.16 47.51 44.85 41.66 48.88L38.59 47.62C38.59 47.62 44 40.83 45 38.23C45.64 36.56 43.6 31.17 43.6 31.17",
    fill: "#252525"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M51.19 38C50.67 41.16 47.51 44.85 41.66 48.88L38.59 47.62C38.59 47.62 44 40.83 45 38.23C45.64 36.56 43.6 31.17 43.6 31.17",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.77 33.7L19.55 39.47L21.91 41.38C21.91 41.38 31.06 38.82 32.32 36.58",
    fill: "#252525"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.77 33.7L19.55 39.47L21.91 41.38C21.91 41.38 31.06 38.82 32.32 36.58",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19.55 39.47C11.96 39.47 13.3 45.67 21.91 41.38L19.55 39.47Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstudiante8);
export default __webpack_public_path__ + "static/media/Estudiante8.00c6f4225ce56fe2bde3e1a061a22b1e.svg";
export { ForwardRef as ReactComponent };